module.exports = __webpack_public_path__ + "img/li.558fdd1f.svg";